/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type CSSProperties, type FC, type JSX, memo, useEffect, useState } from 'react';
// eslint-disable-next-line import/no-cycle
import Label from './Label';
import { CheckboxStyled, Input } from './styled';
import type { ControlProps, FieldType, Target } from '../../index';
import { sumClasses } from '../../../../utils/misc';

export type CustomSvg = {
  svgProps: {
    width: number;
    height: number;
    viewBox: string;
  };
  forTrue: any;
  forFalse: any;
};

interface CheckboxProps extends ControlProps {
  label?: {
    style: CSSProperties;
    text: string | JSX.Element;
  };
  customSvg?: CustomSvg;
  value: boolean;
  type?: FieldType;
  name: string;
  onUpdate: (e: Target) => Promise<void>;
}

const areEqual = (prevProps: CheckboxProps, nextProps: CheckboxProps) => {
  if (prevProps.disabled !== nextProps.disabled) return false;
  if (prevProps.value !== nextProps.value) return false;
  return true;
};

const Checkbox: FC<CheckboxProps> = memo((props) => {
  const { name, className, disabled, style, label, customSvg, type, onUpdate } = props;
  const [value, setValue] = useState(props.value);
  const labelId = `ck_label_${name}`;

  useEffect(() => {
    if (value !== props.value) {
      onUpdate({ target: { name, value } });
    }
  }, [value]);

  useEffect(() => {
    if (value !== props.value) {
      setValue(props.value);
    }
  }, [props.value]);

  return (
    <CheckboxStyled
      className={sumClasses(['container-field oss-ui-checkbox', className || ''])}
      style={style}
      value={value}
      disabled={disabled}
    >
      <Input
        type="checkbox"
        name={name}
        id={name}
        checked={value}
        tabIndex={-1}
        disabled={disabled}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.checked)}
        {...{ 'aria-labelledby': labelId, 'aria-hidden': true }}
        data-testid="checkbox"
      />
      <Label
        name={name}
        label={label}
        value={value}
        labelId={labelId}
        setValue={setValue}
        customSvg={customSvg}
        disabled={disabled}
        type={type}
      />
    </CheckboxStyled>
  );
}, areEqual);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
